// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../graphql/api/index';

export const ComponentTableFragmentDoc = `
    fragment componentTable on ComponentTable {
  table {
    header {
      cells
    }
    body {
      rows {
        cells
      }
    }
  }
}
    `;